import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BRAIN_EXTENDED_FEATURES_ENABLED } from "@/lib/featureFlags";
import { useAssistantName } from "@/hooks/useAssistantName";

function brainNavItems(assistantName) {
  return [
    { to: "/brain", label: `What ${assistantName} reads`, testId: "kb-nav-what-reads" },
    { to: "/brain/documents", label: "Your documents", extendedOnly: true, testId: "kb-nav-your-documents" },
    { to: "/brain/memory", label: `How ${assistantName} remembers`, testId: "kb-nav-how-remembers" },
    { to: "/brain/playground", label: `Test what ${assistantName} knows`, testId: "kb-nav-test-knows" },
    { to: "/brain/voice-memos", label: "Voice memos", extendedOnly: true, testId: "kb-nav-voice-memos" },
  ];
}

export function BrainNav() {
  const { pathname } = useLocation();
  const assistantName = useAssistantName();
  const items = brainNavItems(assistantName).filter((n) => BRAIN_EXTENDED_FEATURES_ENABLED || !n.extendedOnly);
  return (
    <div className="border-b border-slate-200 bg-white px-3 sm:px-6 shrink-0">
      <div className="flex items-center gap-1 min-h-10 overflow-x-auto scrollbar-thin">
        {items.map((n) => (
          <Link
            key={n.to}
            to={n.to}
            className={cn(
              "inline-flex items-center px-3 min-h-10 sm:min-h-0 sm:py-1.5 rounded-md text-[12.5px] font-medium whitespace-nowrap",
              pathname === n.to ? "bg-slate-100 text-slate-900" : "text-slate-600 hover:bg-slate-50",
            )}
            data-testid={n.testId}
          >
            {n.label}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BrainNav;
